const realmCommerceApp = angular.module('realmCommerceApp', ['ngSanitize', 'ngAnimate', 'ngCookies', 'infinite-scroll', 'ngStorage', 'formly', 'formlyBootstrap', 'angucomplete-alt', 'debounce', 'facebook', 'ngComboDatePicker', 'toastr', 'ui.bootstrap', 'noCAPTCHA', 'platformGATracking', 'vcRecaptcha']);

realmCommerceApp.constant('ENVIRONMENT', window.ENVIRONMENT);

window.realmCommerceApp = realmCommerceApp; //this is a hack for backwards compatibility for any angular controllers, services, etc that arent importing app into their own module

export default realmCommerceApp;


// WEBPACK FOOTER //
// ./static/js/app/app.js